import React, { Component, createRef } from "react";
import { QRCodeSVG } from 'qrcode.react';
import { encode as base64_encode } from 'base-64';
import { API_URL, DISPLAY_URL } from "../../../../../../../actions/api";
import ShareEmailCampaignCode from "../elements/ShareEmailCampaignCode";
import { downloadElement } from "../../../../../../../utils";
import withRouter from "../../../../../../CommonComponents/WithRouter";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

class ShareSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copyTooltip: false,
            openPopup: false,
            shareLink: '',
            wallUrl: ''
        }
        this.copyRef = createRef();
        this.qrRef = createRef();

    }

    componentDidMount() {
        this.getShareLink();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.wallsData != this.props.wallsData) this.getShareLink();
    }

    getShareLink = () => {
        const { wallsData, wallDetails, userData } = this.props;
        if (wallsData && wallsData.length > 0) {
            const selectedWall = wallsData?.find(x => x.wall.id == localStorage.getItem('wallId'))
            const timeStamp = new Date() / 1000 | 0;
            const value = `${selectedWall?.wall?.name}---${selectedWall?.wall?.id}&${timeStamp}---${`socialwalll`}---${localStorage.getItem('ownerId')}`;
            const sharelink = base64_encode(value);
            const url = `${DISPLAY_URL}/${localStorage.getItem('wallId')}?social-wall=true&onsite-upload${wallDetails?.wall?.Personalization?.publicAccess ? `&wallKey=` + userData?.user?.user_key : ''}`;
            this.setState({ shareLink: sharelink, wallUrl: url });
        }
    }

    copyCode = () => {
        this.copyRef.current.select();
        navigator.clipboard.writeText(this.copyRef.current.value);
        this.setState({ copyTooltip: true });
        setTimeout(() => {
            this.setState({ copyTooltip: false });
            document.getSelection().removeAllRanges();
        }, 1000);
    }

    //share function to share content
    shareContent = (type) => {
        const { shareLink } = this.state;
        let url = null;
        if (type == 'facebook') {
            url = `https://www.facebook.com/sharer.php?u=${API_URL}/share/sharePostUrl/${shareLink}`;
        } else if (type == 'twitter') {
            url = `https://twitter.com/share?url=${API_URL}/share/sharePostUrl/${shareLink}`;
        } else if (type == 'linkedIn') {
            url = `https://www.linkedin.com/shareArticle?mini=true&url=${API_URL}/share/sharePostUrl/${shareLink}`;
        }
        if (url) window.open(url, "_blank");
    }

    // getQrcode = () => {
    //     const element = document.querySelector('.qr-code-section canvas');
    //     if (element) downloadElement(`qr-snap-up.png`, element, 'canvas');
    // }


        handleDownload = () => {
            const svgElement = this.qrRef.current.querySelector("svg");
            if (!svgElement) return;

            const { wallDetails } = this.props;
            // Clone the SVG element so we don't modify the page
            const clone = svgElement.cloneNode(true);

            // Set large size
            const largeSize = 500; // desired width & height
            clone.setAttribute("width", largeSize);
            clone.setAttribute("height", largeSize);

            // Serialize the cloned SVG
            const serializer = new XMLSerializer();
            const svgData = serializer.serializeToString(clone);
            const svgUrl = URL.createObjectURL(new Blob([svgData], { type: "image/svg+xml;charset=utf-8" }));

            // Draw the SVG onto a canvas and export it as PNG
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = largeSize;
                canvas.height = largeSize;
                const ctx = canvas.getContext("2d");
                ctx.fillStyle = "#ffffff";
                ctx.fillRect(0, 0, largeSize, largeSize);
                ctx.drawImage(img, 0, 0, largeSize, largeSize);
                URL.revokeObjectURL(svgUrl);

                canvas.toBlob((pngBlob) => {
                    if (!pngBlob) return;
                    const pngUrl = URL.createObjectURL(pngBlob);
                    const link = document.createElement("a");
                    const wallName = wallDetails?.wall?.name || "wall";
                    link.href = pngUrl;
                    link.download = `${wallName.replace(/ /g, "-")}-qr-snapup.png`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(pngUrl);
                }, "image/png");
            };
            img.src = svgUrl;
        };
        
        

    OpenSnapUp = () => window.open(this.state.wallUrl, '_blank');

    render() {
        const { wallsData, navigate, status= false } = this.props;
        const { copyTooltip, openPopup, wallUrl } = this.state;
        let htmlCode = '';
        if (wallsData && wallsData.length > 0) {
            htmlCode = `<p style="max-width: 640px;background-color: #fff;padding: 15px;word-wrap: break-word;border-radius: 10px;font-size: 16px;margin:0px;">${''}<a href=${wallUrl}>${wallUrl}</a></p>`;
        }
        return <div className="review-share ps-xxl-0 pe-xxl-3 p-3">
            <div className="link-form">
                <div className="mb-5">
                    <h3>Share & Collect</h3>
                    <p className="mb-0">Time to get your wall out there! Choose your method.</p>
                </div>
                <div className="rs-secone d-flex mb-3">
                    <div className="rss-count"> <span>1</span> </div>
                    <div className="rss-content">
                        <p className="text-dark mb-2 text-capitalize"><strong> The URL Method</strong></p>
                        <p>Give this URL to your audience so they can easily upload photos, videos, and reviews.</p>
                        <div className="input-icon input-icon-right position-relative my-3">
                            <input ref={this.copyRef} onClick={this.copyCode} className="form-control overflow-hidden text-ellipsis text-nowrap mb-0 copy_url edit_url font-weight-bolder" readOnly id="seturlVal" defaultValue={wallUrl} />
                            {copyTooltip ? <span id="copy-success-alert" style={{ display: 'inline-table', marginRight: '60px' }}>Copied!</span> : null}
                            <span className="w-auto">
                                <Button variant="" type="submit" className="copy-btn-url me-3 p-0 border-0" data-factors-click-bind="true" onClick={this.OpenSnapUp}>
                                    <FontAwesomeIcon type={'regular'} icon={'window-restore'} iconClass={''} />
                                </Button>
                                <Button variant="" type="submit" className="p-0 border-0 me-1" onClick={this.copyCode}>
                                    <FontAwesomeIcon type={'regular'} icon={'clone'} iconClass={''} />
                                </Button>
                            </span>
                        </div>
                        <div className="hashtag_social_icons d-flex align-items-center" style={{ color: "#626B76" }}>
                            <FontAwesomeIcon type={'brands'} icon={'facebook'} iconClass={'cursor-pointer'} onClick={(e) => this.shareContent('facebook')} />
                            <span onClick={(e) => this.shareContent('twitter')}>
                                <svg className="px-2  cursor-pointer" id="twitter" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 44.518 44.518">
                                    <path id="Path_5" data-name="Path 5" d="M0,0H44.518V44.518H0Z" fill="none" />
                                    <path id="Path_7" data-name="Path 7" d="M19.036,13.554,30.942,0H28.121L17.778,11.766,9.523,0H0L12.486,17.794,0,32.006H2.821L13.737,19.578l8.72,12.429H31.98Zm-3.865,4.4L13.9,16.177,3.838,2.083H8.172L16.3,13.462l1.262,1.773L28.12,30.025H23.786Zm0,0" transform="translate(6.313 6.281)" fill="#626B76" />
                                </svg>
                            </span>
                            <FontAwesomeIcon type={'brands'} icon={'linkedin'} iconClass={'cursor-pointer me-3'} onClick={(e) => this.shareContent('linkedIn')} />
                            <FontAwesomeIcon type={'regular'} icon={'envelope'} iconClass={'cursor-pointer '} onClick={() => this.setState({ openPopup: true })} />
                        </div>
                    </div>
                </div>

                {wallUrl ? <div className="rs-secone d-flex py-3">
                    <div className="rss-count">
                        <span>{2}</span>
                    </div>
                    <div className="rss-content">
                        <p className="text-dark mb-3"><strong>{status ? 'Share QR Code' : 'Snap Up / Share QR Code'}</strong></p>
                        <div ref={this.qrRef}  className="qr-code-section ">
                            <div className="d-flex shadow mb-md-5 mb-4 bg-white p-3 rounded">
                                <QRCodeSVG value={wallUrl} size={90} />
                                <div className="qr-rightsec">
                                    <p>Provide your audience with this QR code to scan and upload their UGC instantly.</p>
                                </div>
                            </div>
                            <button className="btn btn-dark pe-auto" onClick={this.handleDownload}>Download QR</button>
                            {!status ? <button className="btn btn-outline pe-auto" onClick={() => { navigate(`/wall/personalize/${localStorage.getItem('wallId')}?tab=snapup`) }}>QR Settings</button> : null}
                        </div>
                    </div>
                </div> : null}

            </div>
            {openPopup ? <ShareEmailCampaignCode show={openPopup} setClosePopup={() => this.setState({ openPopup: false })} shareurl={htmlCode} /> : null}
        </div>
    }
}

export default withRouter(ShareSection);